var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-dialog-header"},[_c('div'),_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("default",function(){return [_c('span',{staticClass:"close",style:({backgroundImage: `url(${require('@/assets/image/base/close/icons_24pt_close_1.svg')})`}),on:{"click":function($event){return _vm.$emit('close')}}})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }